import React from 'react'
import Navbar from 'react-bootstrap/Navbar'
import useAuth from '../routes/useAuth'
import { Button, Space, Spin, Typography } from 'antd'
import { useNavigate } from 'react-router-dom'
// import logo from '../assets/Logo/logosidetext.webp'
import { ArrowRightOutlined } from '@ant-design/icons'
import { useTranslation } from 'react-i18next'

const LandingPageNavbar = () => {
    const { isFetching, isVerified } = useAuth()
    const navigate = useNavigate()
    const { t } = useTranslation()
    const LoginAndRegisterButton = () => {
        return (
            <Space>
                <Button type="text"  onClick={() => navigate('/login')} style={{ textDecoration: "none" }}> {t('500127')/** Log in*/}</Button>
                <Button type="primary" onClick={() => navigate('/register')} style={{ borderRadius: "0px", textDecoration: "none" }}>{t('500128')/** Sign up */}</Button>
            </Space>
        )
    }

    const ContinueToCalculatorButton = () => (
        <Space>
            {/* <Button type="text" href='/home'>Continue to Calculator</Button> */}
            <Button type='text' onClick={() => navigate('/home')}>
                <Typography.Title level={3}>Continue to Calculator <ArrowRightOutlined /></Typography.Title>
            </Button>
        </Space>
    )

    return (
        <Navbar
            expand="md"
            class="row "
            id="nav"
            expanded="true"
            style={{ justifyContent: "center", backgroundColor: "white", padding: "0px 1.5rem" }}
        >
            <div style={{ width: "100%", maxWidth: "1280px", display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                <div >
                    <img
                        src={"/images/logosidetext.webp"}
                        alt="logo-RealtimeLSS"
                        loading="eager" 
                        width={250}
                        height={73.31}
                        fetchpriority="high"
                        style={{ maxWidth: "100%", height: "auto", objectFit: "contain" }}
                    />
                </div>
                {
                    isFetching ? (
                        <Spin />
                    ) : (
                        isVerified ? (
                            <ContinueToCalculatorButton />
                        ) : (
                            <LoginAndRegisterButton />
                        )
                    )
                }
            </div >
        </Navbar >

    )
}

export default LandingPageNavbar
